export class ProductRange{
    ProductRangeID : number;
    ProductRangeName : string;
    ProductRangeDescription : string;
    IsActive : boolean = true;
    ModifiedBy: number;

    TargetYear?: string;
    
}